import gql from 'graphql-tag';

import credentialFragment from './credentialFragment';

export const credentialUpsertFragment = gql`
  fragment credentialUpsertFragment on CredentialUpsert {
    dokkioClass
    isNew
    credential {
      ...credentialFragment
    }
  }
  ${credentialFragment}
`;
export default credentialUpsertFragment;
